import axios from "axios";

const distApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

distApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("agi_dist_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

distApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname === "/distributor") {
      localStorage.removeItem("agi_dist_token");
      window.location.href = "/distributors";
    }
    return Promise.reject(err);
  }
);

export default distApi;
